import { CreateSuperPackData, SuperPacksClient } from '../types'

export const createSuperPack = (base: SuperPacksClient) => (data?: CreateSuperPackData) =>
  base.requester.post('', data, { withCredentials: true })
